import {JobInstruments} from '../models/instrument/jobInstruments.model';

export namespace Instruments {
  export class GetJobInstruments {
    static readonly type = '[Instruments api] GetJobInstruments';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateJobInstruments {
    static readonly type = '[Instruments api] UpdateJobInstruments';

    constructor(public jobInstruments: JobInstruments) {
    }
  }
}
